import React, { Component } from "react"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"
import ArticleColorUsp from "../article-color-usp/article-color-usp-component"

export default class ArticleTextUsp extends Component {
  render() {
    const topPadding = SelectionFactoryHelper.getFromSelectionFactory(this.props.topPadding)
    return (
      <div className={`article-text-usp ${topPadding ? topPadding : ""}`}>
        <div className="w--wider">
          <div className="top-text" dangerouslySetInnerHTML={{ __html: this.props.topText }}></div>
          <ArticleColorUsp {...this.props.uspBlock} />
          <div className="bottom-text" dangerouslySetInnerHTML={{ __html: this.props.bottomText }}></div>
          <div className="clear"></div>
        </div>
      </div>
    )
  }
}
